import React from 'react';
import { buildHouseTypeOptions } from '../../../utils/houseTypeOptionsUtils';

function MobileHouseTypeField({
  houseTypeData,
  selectedHouseTypes,
  onHouseTypeChange,
  disabled = false,
}) {
  const houseTypeOptions = buildHouseTypeOptions(houseTypeData);
  return (
    <div>
      <fieldset className="px-4">
        <legend className="block font-medium text-black text-sm mb-3">
          House type
        </legend>

        <div className="space-y-3 columns-2">
          {houseTypeOptions.map((type) => (
            <label
              key={type.value}
              className="flex items-center gap-3 break-inside-avoid"
            >
              <input
                type="checkbox"
                checked={selectedHouseTypes.includes(type.value)}
                onChange={
                  disabled ? undefined : () => onHouseTypeChange(type.value)
                }
                className="w-4 h-4 border border-[#EBEBEB] bg-grey-100"
                disabled={disabled}
              />
              <span
                className={`text-sm font-light ${disabled ? 'opacity-50' : ''}`}
              >
                {type.label}
              </span>
            </label>
          ))}
        </div>
      </fieldset>
    </div>
  );
}

export default MobileHouseTypeField;
